import { type BackendSource, getBackendSourceLabel, getLocalBackendOrigin } from "@/lib/backendSource";

export function buildCapabilitiesBootstrapError(error: Error, activeSource: BackendSource): string {
  const backendLabel = getBackendSourceLabel(activeSource);
  const localHint =
    activeSource === "localhost"
      ? ` If you chose a local backend, confirm bin/rails server is running at ${getLocalBackendOrigin()}.`
      : "";

  return `Could not load your permissions from ${backendLabel}. ${error.message}${localHint}`;
}
